import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import CustomButton from '../../../Utility/Components/CustomButton';
import Cookies from 'js-cookie';
import { setToken } from '../Actions/LoginAction';
import { connect } from 'react-redux';

function VariantsExample(props) {

    return (
        <>
            {['Primary'].map(
                (variant) => (
                    <DropdownButton
                        //as={ButtonGroup}
                        key={variant}
                        id={`dropdown-variants-${variant}`}
                        variant={variant.toLowerCase()}
                        title={localStorage.getItem('i18nextLng') != null ? localStorage.getItem('i18nextLng').toUpperCase() : 'EN'}
                        onSelect={props.lanOnSelect.bind(this)}
                    >
                        <Dropdown.Item eventKey="en">EN</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item eventKey="fr">FR</Dropdown.Item>

                    </DropdownButton>
                ),
            )}
        </>
    );
}

class CommonLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'email' // 'email' or 'phone'
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedActiveTab === "email" && prevProps.selectedActiveTab !== this.props.selectedActiveTab) {
            this.setActiveTab("email");
        }
    }

    setActiveTab = (tab) => {
        this.setState({ activeTab: tab }, () => {
            // Reset password, phone, otp, token after tab change

            this.props.setemail("")
            this.props.setpassword("")
            this.props.setPhone("")
            this.props.setOtpSent(false)
            this.props.setIsRemember(false)
            setToken('', '', '', '', [], [], "");
            if (this.props.sessionToken) {
                this.props.setSessionToken("");
            }
            if (this.props.clearErrors) {
                this.props.clearErrors();
            }
        });
    }



    render() {
        const { pageBackground, appContainerInner, loginBoxInner, logoBoxInner, companyLogo, titleLabel, webTitle, loginFormDiv, rememberForgotInner, rememberTitle, forgotTitle, submitTitle, checkboxContainer, checkmark, loginBtn, checkboxType, buttonType, parentClassName, checkboxName, checkboxValue, passInputClass, passLockIcon, passEyeIcon, errorClass, passPlaceholder, passName, lockClass, eyeClass, eyeSlash, showPassword, showText, passwordLock } = this.props;
        const { activeTab } = this.state;
        // console.log("this.props.otpSent", this.props.otpSent)
        return (
            <div className={pageBackground}>
                <div className={appContainerInner}>
                    <div className={loginBoxInner}>
                        <div className={logoBoxInner}>
                            <div className="titleposition">
                                <img src={require('../../../Utility/Public/images/logo.png')} className="logoInner" />
                            </div>
                        </div>

                        {/* Tab Buttons */}
                        <div className="login-tabs">
                            <button
                                type="button"
                                className={`tab-btn ${activeTab === 'email' ? 'active' : ''}`}
                                onClick={() => this.setActiveTab('email')}
                            >
                                PASSWORD
                            </button>
                            <button
                                type="button"
                                className={`tab-btn ${activeTab === 'phone' ? 'active' : ''}`}
                                onClick={() => this.setActiveTab('phone')}
                            >
                                OTP
                            </button>
                        </div>

                        <form className={loginFormDiv}>
                            {activeTab === 'email' ? (
                                <>
                                    {/* login email field */}
                                    <div className={parentClassName}>
                                        <input type="text" onChange={this.props.handleChange} name="email" value={this.props.email} placeholder="Email" className={passInputClass} id="login_useremail" onFocus={this.props.handleonFocus} onBlur={this.props.handleonBlur} onKeyDown={this.props.handleKeyPress} />
                                        <div className={errorClass}>{this.props.emailError}</div>
                                    </div>
                                    {/* login password field */}
                                    <div className={parentClassName}>
                                        <input type={this.props.passtype == "text" ? "text" : "password"} onChange={this.props.handleChange} name={passName} value={this.props.password} placeholder="Password" className={passInputClass} id='login_userpassword' onFocus={this.props.handleonFocus} onBlur={this.props.handleonBlur} onKeyDown={this.props.handleKeyPress} />
                                        {!passwordLock ?
                                            <span className={passEyeIcon} onClick={showText}>
                                                <i className={eyeSlash} aria-hidden="true"></i>
                                            </span>
                                            :
                                            <span className={passEyeIcon} onClick={showPassword}>
                                                <i className={eyeClass} aria-hidden="true"></i>
                                            </span>
                                        }
                                        <div className={errorClass}>{this.props.passwordError}</div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    {/* Phone input */}
                                    <div className={parentClassName}>
                                        <input
                                            type="tel"
                                            onChange={this.props.handleChange}
                                            name="phone"
                                            value={this.props.phone || ""}
                                            placeholder="Phone Number (10 digits)"
                                            className={passInputClass}
                                            maxLength="10"
                                            onFocus={this.props.handleonFocus}
                                            onBlur={this.props.handleonBlur}
                                        />
                                        <div className={errorClass}>{this.props.phoneError}</div>
                                        <div className="subtext_helper">Enter 10 digit phone number without country code</div>
                                    </div>

                                    {/* OTP field - conditionally rendered */}
                                    {this.props.otpSent && (
                                        <div className={parentClassName}>
                                            <div className="otp_sent_message">OTP has been sent to your phone</div>
                                            <input
                                                type="text"
                                                onChange={this.props.handleChange}
                                                name="otp"
                                                value={this.props.otp || ""}
                                                placeholder="Enter OTP"
                                                className={passInputClass}
                                                maxLength="6"
                                            />
                                            <div className={errorClass}>{this.props.otpError}</div>
                                        </div>
                                    )}
                                </>
                            )}
                            {/* remember me field - only for email login */}
                            {activeTab === 'email' && (
                                <div className='rememberMe'>
                                    <label className="remembercheckboxcontainer">Remember me
                                        <input type="checkbox" checked={this.props.isRemember} onChange={(e) => this.props.rememberMe(e)} />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            )}

                            {/* login button - conditional based on tab */}
                            <div className="loginFormInnerDiv logbtndiv">
                                {activeTab === 'email' ? (
                                    <CustomButton
                                        onClick={this.props.login}
                                        className="login-btn btn btn-primary"
                                        children='Login'
                                        type="button"
                                    />
                                ) : this.props.otpSent ? (
                                    <>
                                        <CustomButton
                                            onClick={this.props.verifyOtp}
                                            className="login-btn btn btn-primary"
                                            children='Verify OTP'
                                            type="button"
                                        />
                                        <div className="resend_otp_container">
                                            <span
                                                className="resend_otp_link"
                                                onClick={this.props.requestOtp}
                                            >
                                                Resend OTP
                                            </span>
                                        </div>
                                    </>
                                ) : (
                                    <CustomButton
                                        onClick={this.props.requestOtp}
                                        className="login-btn btn btn-primary"
                                        children='Request OTP'
                                        type="button"
                                    />
                                )}
                            </div>
                        </form>
                        {/* forget password  */}
                        {activeTab === 'email' &&
                            <div className={rememberForgotInner}>
                                <p onClick={this.props.forgotPassword}><span>Forgot your password ?</span></p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}


CommonLogin.defaultProps = {
    email: "",
    password: "",
    pageBackground: 'loginBackground',
    appContainerInner: 'appContainerInner',
    loginBoxInner: 'login_box_inner',
    logoBoxInner: 'logo-box-inner',
    companyLogo: 'logo-box-top-logo',
    titleLabel: 'loginTitle',
    loginFormDiv: 'loginFormDiv',
    rememberForgotInner: 'loginFormInnerDiv forgot_password_property',
    checkboxContainer: 'custom_checkbox_container_log',
    checkmark: 'checkmarkCheckbox',
    loginBtn: 'login-btn',
    parentClassName: 'loginFormInnerDiv',
    passInputClass: 'input__fields_property',
    passLockIcon: 'passwordLockIcon',
    passEyeIcon: 'passwordEyeIcon',
    errorClass: 'col-md-12 errorClass error_div',
    passName: 'password',
    lockClass: 'fa fa-lock',
    eyeSlash: 'fa fa-eye-slash',
    eyeClass: 'fa fa-eye',

    checkboxType: 'checkbox',
    checkboxName: 'remember_me',
    checkboxValue: '',
    buttonType: 'button',

    passPlaceholder: 'Mot de passe',
    webTitle: 'HR Management System',
    rememberTitle: 'Remember Me',
    forgotTitle: 'Mot de passe oublié?',
    submitTitle: 'Se connecter'
}

const mapStateToProps = (globalState) => {
    return {
        token: globalState.LoginReducer.token
    };
}

export default connect(mapStateToProps, { setToken })(CommonLogin);
// export default CommonLogin;
